import React from "react";

const Structure = () => {
  return <div>Structure</div>;
};

export default Structure;
